import {Exclude, Expose, Type} from "class-transformer";
import {OfferLocation} from "@core/shared/models/offer/offer-location";
import {Transport} from "@core/shared/models/transport";

@Exclude()
export class OfferLocationTransport {

    @Expose()
    id: number;

    @Expose()
    isArrival: boolean;

    @Expose()
    isDeparture: boolean;

    @Expose()
    transport: Transport;

    @Expose()
    distance: number;

    @Expose()
    drivingDuration: number;

    @Expose()
    walkingDuration: number;

    @Expose()
    cyclingDuration: number;

    @Expose()
    offerLocation?: OfferLocation;
}
